import { FC, ReactNode } from 'react';
import { Flex } from 'antd';
import { TextSecondary } from './typography';

type Props = {
  upperText?: ReactNode | null;
  lowerText?: ReactNode | null;
  upperPlaceholder?: string;
  lowerPlaceholder?: string;
};

export const ObjectHeader: FC<Props> = ({
  upperText,
  lowerText,
  upperPlaceholder = '-',
  lowerPlaceholder = '-',
}) => (
  <Flex vertical gap="small">
    <small>
      <strong>
        {upperText || <TextSecondary>{upperPlaceholder}</TextSecondary>}
      </strong>
    </small>
    <h4>{lowerText || <TextSecondary>{lowerPlaceholder}</TextSecondary>}</h4>
  </Flex>
);
